/**
 * 약관·방침을 **앱 밖 화면**(네이티브 인앱 웹뷰 모달·브라우저 새 탭)으로 열 주소에 지금 화면
 * 언어를 싣는다. 그 화면은 앱이 고른 언어를 못 볼 수 있다 — `PolicyPage` 가 `?lang=` 을
 * 화면 언어보다 앞세운다.
 *
 * 주소의 다른 쿼리와 해시는 그대로 둔다. 주소가 `URL` 로 읽히지 않으면(env 오타 등) 손대지
 * 않고 돌려준다 — 언어를 못 싣는 것이 문서를 못 여는 것보다 낫다.
 */
export const policyUrl = (url: string, lang: string): string => {
  try {
    const next = new URL(url);
    next.searchParams.set('lang', lang);
    return next.toString();
  } catch {
    return url;
  }
};
